<div class="tool-content-container">
  <div class="tool-description">
    Select a
    <instruction-step-link link="recommender-type" text="Recommender Type" />,
    enter a
    <instruction-step-link
      link="student-id"
      text="Student ID"
      appendedText="(Relevant form fields will be pre-populated)"
    />, select a
    <instruction-step-link
      link="semesters"
      text="Semester"
      appendedText="to Recommend"
    />, and click the submit button to generate results for course recommender.
    <!-- <b class="instructions-title">To generate results for course recommender:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="recommender-type" text="Recommender Type" />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Enter a
    <instruction-step-link
      link="student-id"
      text="Student ID"
      appendedText="(Relevant form fields will be pre-populated)"
    />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link
      link="semesters"
      text="Semester"
      appendedText="to Recommend"
    />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Click on the submit button -->
    <!-- <br /><br /> -->
    <br /><br />
    <b class="important-note">
      *Additional courses can be added to taken courses by selecting a course
      number and course grade.
    </b>
  </div>

  <!------------------------ Web View ------------------------>
  <div
    class="table-parent-div mat-elevation-z8"
    *ngIf="!!coursesRecommendedData.length && webView"
  >
    <table mat-table [dataSource]="coursesRecommendedData">
      <!-- Course Rank Column -->
      <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef>Course Rank</th>
        <td mat-cell *matCellDef="let i = index">{{ i + 1 }}</td>
      </ng-container>

      <!-- Course Code Column -->
      <ng-container matColumnDef="course_code">
        <th mat-header-cell *matHeaderCellDef>Course Code</th>
        <td mat-cell *matCellDef="let course">{{ course['course_code'] }}</td>
      </ng-container>

      <!-- Course Name Column -->
      <ng-container matColumnDef="course_name">
        <th mat-header-cell *matHeaderCellDef>Course Name</th>
        <td mat-cell *matCellDef="let course">{{ course['course_name'] }}</td>
      </ng-container>

      <!-- Pass Rate Column -->
      <ng-container matColumnDef="pass_rate">
        <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
        <td mat-cell *matCellDef="let course">{{ course['pass_rate'] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-------------------- Mobile View -------------------->
  <div *ngIf="coursesRecommendedData.length && mobileView">
    <mat-table
      [dataSource]="coursesRecommendedData"
      class="mat-elevation-z8 table-container"
    >
      <!-- Course Rank Column -->
      <ng-container matColumnDef="rank">
        <mat-header-cell *matHeaderCellDef>Course Rank</mat-header-cell>
        <mat-cell *matCellDef="let i = index"
          ><span>Course Rank:</span> {{ i + 1 }}</mat-cell
        >
      </ng-container>

      <!-- Course Code Column -->
      <ng-container matColumnDef="course_code">
        <mat-header-cell *matHeaderCellDef>Course Code</mat-header-cell>
        <mat-cell *matCellDef="let course"
          ><span>Course Code:</span> {{ course['course_code'] }}</mat-cell
        >
      </ng-container>

      <!-- Course Name Column -->
      <ng-container matColumnDef="course_name">
        <mat-header-cell *matHeaderCellDef>Course Name</mat-header-cell>
        <mat-cell *matCellDef="let course"
          ><span>Course Name:</span> {{ course['course_name'] }}</mat-cell
        >
      </ng-container>

      <!-- Pass Rate Column -->
      <ng-container matColumnDef="pass_rate">
        <mat-header-cell *matHeaderCellDef>Pass Rate</mat-header-cell>
        <mat-cell *matCellDef="let course"
          ><span>Pass Rate:</span> {{ course['pass_rate'] }}</mat-cell
        >
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <back-button></back-button>
</div>
